// Incident Type Constants

export const OUTCOME_MEDICATION = "medication";

// NDIS Reportable Incidents Data
// Timeframes are calculated from when a registered NDIS provider became aware of the incident
export const REPORTABLE_INCIDENTS_TABLE = [
  {
    incident: "Death of a person with disability.",
    timeframe: "24 hours",
    critical: true,
  },
  {
    incident: "Serious injury of a person with disability.",
    timeframe: "24 hours",
    critical: true,
  },
  {
    incident: "Abuse or neglect of a person with disability.",
    timeframe: "24 hours",
    critical: true,
  },
  {
    incident: "Unlawful sexual or physical contact with, or assault of, a person with disability.",
    timeframe: "24 hours",
    critical: true,
  },
  {
    incident: "Sexual misconduct against, or in the presence of, a person with disability, including grooming of the person for sexual activity.",
    timeframe: "24 hours",
    critical: true,
  },
  {
    incident: "Use of a restrictive practice that is unauthorised by your state or territory, or does not follow a behaviour support plan for the person with disability.",
    timeframe: "5 business days",
    critical: false,
  },
];
